<!-- The product card group is owned by the commerce team -->
<script setup lang="ts">
import { computed } from 'vue'

import { ProductCardGroup } from '@toni/commerce-ui'

import { useContentBlock } from '../../content-blocks/composables/use-content-block'

const props = defineProps<{ id: string }>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'productCardGroup')
</script>

<template>
  <ProductCardGroup v-bind="contentBlock.data?.productCardGroup" />
</template>
